import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { CardComponentModule, SharedModule } from 'lib-trend-core';
import { SettingsTemplateListModule } from '../channel/channel-config/settings-template-list/settings-template-list.module';
import { RcsMessageModule } from '../rcs-message/rcs-message.module';
import { WaTemplateModule } from '../wa-template/wa-template.module';
import { CampaignEvoTemplateComponent } from './campaign-evo-template/campaign-evo-template.component';
import { CampaignFormComponent } from './campaign-form/campaign-form.component';
import { CampaignListComponent } from './campaign-list/campaign-list.component';
import { CampaignMessagePayloadComponent } from './campaign-message-payload/campaign-message-payload.component';
import { CampaignMessageComponent } from './campaign-message/campaign-message.component';
import { CampaignRoutingModule } from './campaign-routing.module';
import { CampaignTemplatesComponent } from './campaign-templates/campaign-templates.component';
import { CampaignWalletComponent } from './campaign-wallet/campaign-wallet.component';
import { CampaignWaTemplateMessageComponent } from './campaign-wa-template-message/campaign-wa-template-message.component';
import { CampaingSaveConfirmModalComponent } from './campaing-save-confirm-modal/campaing-save-confirm-modal.component';
import { GoToTabDirective } from './go-to-tab.directive';
import { CampaignCloudApiTemplateComponent } from './campaign-cloud-api-template/campaign-cloud-api-template.component';
import { CampaignRcsBillingComponent } from './campaign-rcs-billing/campaign-rcs-billing.component';
import { CampaignRefreshIntervalComponent } from './shared/campaign-refresh-interval/campaign-refresh-interval.component';

@NgModule({
  imports: [
    SharedModule,
    CampaignRoutingModule,
    WaTemplateModule,
    CardComponentModule,
    SettingsTemplateListModule,
    RcsMessageModule,
    PickerModule,
    NgxChartsModule
  ],
  declarations: [
    CampaignListComponent,
    CampaignFormComponent,
    CampaignEvoTemplateComponent,
    CampaingSaveConfirmModalComponent,
    CampaignWaTemplateMessageComponent,
    CampaignMessageComponent,
    CampaignMessagePayloadComponent,
    CampaignCloudApiTemplateComponent,
    CampaignRcsBillingComponent,
    CampaignRefreshIntervalComponent,
    GoToTabDirective,
    CampaignWalletComponent,
    CampaignTemplatesComponent
  ],
  exports: [
    CampaignListComponent,
    CampaignFormComponent,
    CampaignEvoTemplateComponent,
    CampaingSaveConfirmModalComponent,
    CampaignWaTemplateMessageComponent,
    CampaignMessageComponent,
    CampaignMessagePayloadComponent,
    CampaignCloudApiTemplateComponent,
    GoToTabDirective,
  ],
  providers: [
    DatePipe,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
  ]
})
export class CampaignModule { }
